import { Injectable } from '@angular/core';
import { ApiService } from '@fgb/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoadedTicket } from '../models/loaded-ticket.model';

@Injectable({ providedIn: 'root' })
export class LoadedTicketsService {
  constructor(private api: ApiService) {}

  getUpcomingTickets(): Observable<LoadedTicket[]> {
    return this.api.getChildData<LoadedTicket[]>('loadedtickets', 'upcoming').pipe(catchError(() => of([])));
  }
}
